import { get } from "./api";

export type AppType =
  | "Base Work+"
  | "Base HRM+"
  | "Base Platform"
  | "Base Info+"
  | "Base Finance+"
  | "Others";

export type AppCatalog = {
  appTypes: { appType: AppType; apps: string[] }[];
  packages: { code: string; family: string; tier: string | null; label: string; apps: string[] }[];
  alwaysFreeApps: string[];
  allApps: string[];
};

/** T128/FR-064: fetched rather than hardcoded, so the frontend's tag input, company app picker,
 * and question-bank filter all read the same catalogue the backend validates against. */
export function getAppCatalog() {
  return get<AppCatalog>("/co/app-catalog");
}

/** Case-insensitive resolution to the catalogue's canonical spelling — "wework", "WeWork" and
 * "WEWORK" all become "Wework" (FR-070). Returns null when nothing matches, so the caller can
 * warn. Mirrors `normalizeAppTag` on the backend; both are needed because the UI warns before
 * saving while the server normalizes whatever actually arrives. */
export function normalizeTag(input: string, allApps: string[]): string | null {
  const lower = input.trim().toLowerCase();
  return allApps.find((app) => app.toLowerCase() === lower) ?? null;
}
